(function () {
  var activeTimer = null;

  function ensureToast() {
    var toast = document.querySelector('[data-acm-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'acm-toast';
    toast.setAttribute('data-acm-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.hidden = true;
    toast.innerHTML = '<span class="acm-mono">OK</span><span data-acm-toast-text>Added to cart</span><a href="/cart" class="acm-mono acm-toast-cta">VIEW CART &rarr;</a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message) {
    var toast = ensureToast();
    var text = toast.querySelector('[data-acm-toast-text]');
    if (text) text.textContent = message || 'Added to cart';
    toast.hidden = false;
    toast.classList.remove('is-hiding');

    clearTimeout(activeTimer);
    activeTimer = setTimeout(function () {
      toast.classList.add('is-hiding');
      setTimeout(function () {
        toast.hidden = true;
        toast.classList.remove('is-hiding');
      }, 180);
    }, 3200);
  }

  function updateCartCount(count) {
    var countEl = document.querySelector('.acm-nav-cart-count');
    if (!countEl || typeof count !== 'number') return;
    countEl.textContent = String(count).padStart(2, '0').slice(-2);
    var cartLink = document.querySelector('.acm-nav-cart');
    if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + count + ' items');
  }

  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatAmount(amount) {
    return '$' + Number(amount || 0).toFixed(2);
  }

  function normalizeQuantity(value) {
    var quantity = parseInt(value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getProductQuantity() {
    var input = document.querySelector('[data-acm-qty-input]');
    return normalizeQuantity(input && input.value);
  }

  function syncProductQuantity(root, quantity) {
    var normalized = normalizeQuantity(quantity);
    var scope = root || document;
    scope.querySelectorAll('[data-acm-qty-input]').forEach(function (input) {
      input.value = normalized;
    });
    scope.querySelectorAll('[data-acm-form-quantity]').forEach(function (input) {
      input.value = normalized;
    });
  }

  function getPurchaseBreakdown(root) {
    var priceCents = Number(root && root.getAttribute('data-selected-variant-price')) || 0;
    var quantity = getProductQuantity();
    var price = priceCents / 100;
    var logisticsRate = Number(root.getAttribute('data-transportation-rate') || 0.08);
    var cardRate = Number(root.getAttribute('data-credit-card-rate') || 0.0295);
    var divisor = 1 + logisticsRate + cardRate;
    var unitCost = price / divisor;
    var unitLogistics = unitCost * logisticsRate;
    var unitCard = price - unitCost - unitLogistics;

    return {
      card: unitCard * quantity,
      cost: unitCost * quantity,
      logistics: unitLogistics * quantity,
      totalCents: priceCents * quantity,
    };
  }

  function syncPurchaseTotals(root) {
    if (!root) return;
    var totals = getPurchaseBreakdown(root);
    var setText = function (selector, value) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.textContent = value;
      });
    };

    setText('[data-acm-cta-price]', formatMoney(totals.totalCents));
    setText('[data-acm-sticky-price]', formatMoney(totals.totalCents));
    setText('[data-acm-receipt-cost]', formatAmount(totals.cost));
    setText('[data-acm-receipt-logistics]', formatAmount(totals.logistics));
    setText('[data-acm-receipt-card]', formatAmount(totals.card));
    setText('[data-acm-receipt-total]', formatMoney(totals.totalCents));
    setText('[data-acm-receipt-mini-cost]', formatAmount(totals.cost));
    setText('[data-acm-receipt-mini-logistics]', formatAmount(totals.logistics));
    setText('[data-acm-receipt-mini-card]', formatAmount(totals.card));
    setText('[data-acm-receipt-mini-fees]', formatAmount(totals.logistics + totals.card));
    setText('[data-acm-receipt-mini-total]', formatMoney(totals.totalCents));
  }

  function syncMemberSummary() {
    var modal = document.querySelector('[data-acm-member-modal]');
    var root = document.querySelector('[data-acm-pdp]');
    if (!modal || !root) return;

    var addButton = modal.querySelector('[data-acm-member-add]');
    var selectedPlan = modal.querySelector('input[name="acm_membership_variant"]:checked');
    var productAvailable = addButton && addButton.getAttribute('data-product-available') === 'true';
    var productQuantity = productAvailable ? getProductQuantity() : 0;
    var productPrice = Number(root.getAttribute('data-selected-variant-price')) || 0;
    var planPrice = Number(selectedPlan && selectedPlan.getAttribute('data-plan-price')) || 0;
    var planTitle = selectedPlan && selectedPlan.getAttribute('data-plan-title');
    var itemTotal = productPrice * productQuantity;
    var total = selectedPlan ? planPrice + itemTotal : itemTotal;
    var setText = function (selector, value) {
      var el = modal.querySelector(selector);
      if (el) el.textContent = value;
    };

    setText('[data-acm-member-summary-plan]', selectedPlan ? (planTitle ? planTitle + ' - ' : '') + formatMoney(planPrice) : 'Select below');
    setText('[data-acm-member-summary-qty]', String(productQuantity || 1));
    setText('[data-acm-member-summary-item]', productAvailable ? formatMoney(itemTotal) : 'Allocation pending');
    setText('[data-acm-member-summary-total]', formatMoney(total));
    if (addButton) {
      addButton.disabled = !selectedPlan;
      addButton.textContent = selectedPlan && productAvailable
        ? 'Start access + add item - ' + formatMoney(total)
        : 'Select access period';
    }
  }

  function updateReceipt(root, variant) {
    if (!root || !variant) return;
    var priceCents = Number(variant.price || 0);
    var price = priceCents / 100;
    var logisticsRate = Number(root.getAttribute('data-transportation-rate') || 0.08);
    var cardRate = Number(root.getAttribute('data-credit-card-rate') || 0.0295);
    var divisor = 1 + logisticsRate + cardRate;
    var cost = price / divisor;
    var logistics = cost * logisticsRate;
    var card = price - cost - logistics;

    var setText = function (selector, value) {
      var el = root.querySelector(selector);
      if (el) el.textContent = value;
    };

    setText('[data-acm-price]', formatMoney(priceCents));
    setText('[data-acm-comp-ours]', formatMoney(priceCents));
    setText('[data-acm-member-summary-price]', formatMoney(priceCents));
    setText('[data-acm-sku]', variant.sku || root.getAttribute('data-product-title') || '');
    setText('[data-acm-meta-sku]', variant.sku || '');
    setText('[data-acm-variant-label]', variant.title && variant.title !== 'Default Title' ? variant.title : '');
    setText('[data-acm-meta-weight]', variant.title && variant.title !== 'Default Title' ? variant.title : '');

    var selectedId = String(variant.id || '');
    root.setAttribute('data-selected-variant-id', selectedId);
    root.setAttribute('data-selected-variant-price', String(priceCents));
    root.querySelectorAll('[data-acm-form-variant-id]').forEach(function (input) {
      input.value = selectedId;
    });
    root.querySelectorAll('[data-product-variant-id]').forEach(function (el) {
      el.setAttribute('data-product-variant-id', selectedId);
    });
    root.querySelectorAll('[data-product-available]').forEach(function (el) {
      el.setAttribute('data-product-available', variant.available ? 'true' : 'false');
    });
    root.querySelectorAll('[data-acm-member-trigger-label-available]').forEach(function (el) {
      el.hidden = !variant.available;
    });
    root.querySelectorAll('[data-acm-member-trigger-label-unavailable]').forEach(function (el) {
      el.hidden = Boolean(variant.available);
    });

    var cta = root.querySelector('[data-acm-main-cta]');
    if (cta && cta.closest('form')) cta.disabled = !variant.available;
    syncPurchaseTotals(root);
    syncStickyCta(root, variant);
    syncMemberSummary();
  }

  function syncStickyCta(root, variant) {
    if (!root || !variant) return;
    var priceCents = Number(variant.price || 0);
    root.querySelectorAll('[data-acm-sticky-price]').forEach(function (el) {
      el.textContent = formatMoney(priceCents);
    });
    root.querySelectorAll('[data-acm-sticky-submit]').forEach(function (button) {
      button.disabled = !variant.available;
    });
  }

  function initVariantSelectors() {
    document.querySelectorAll('[data-acm-pdp]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-acm-variants-json]');
      var select = root.querySelector('[data-acm-variant-select]');
      if (!jsonEl || !select) return;

      var variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent || '[]');
      } catch (error) {
        variants = [];
      }

      select.addEventListener('change', function () {
        var selected = variants.find(function (variant) {
          return String(variant.id) === String(select.value);
        });
        updateReceipt(root, selected);
      });
    });
  }

  function initQuantitySelectors() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-acm-qty-step]');
      if (!button) return;
      var root = button.closest('[data-acm-pdp]');
      if (!root) return;
      event.preventDefault();
      var step = parseInt(button.getAttribute('data-acm-qty-step') || '0', 10);
      syncProductQuantity(root, getProductQuantity() + step);
      syncPurchaseTotals(root);
      syncMemberSummary();
    });

    document.addEventListener('input', function (event) {
      var input = event.target.closest('[data-acm-qty-input]');
      if (!input) return;
      var root = input.closest('[data-acm-pdp]');
      if (!root) return;
      syncProductQuantity(root, input.value);
      syncPurchaseTotals(root);
      syncMemberSummary();
    });

    document.addEventListener('blur', function (event) {
      var input = event.target.closest('[data-acm-qty-input]');
      if (!input) return;
      var root = input.closest('[data-acm-pdp]');
      if (!root) return;
      syncProductQuantity(root, input.value);
      syncPurchaseTotals(root);
      syncMemberSummary();
    }, true);

    document.querySelectorAll('[data-acm-pdp]').forEach(function (root) {
      var input = root.querySelector('[data-acm-qty-input]');
      if (!input) return;

      syncProductQuantity(root, input.value);
      syncPurchaseTotals(root);
    });
  }

  function initThumbs() {
    document.querySelectorAll('[data-acm-pdp]').forEach(function (root) {
      var main = root.querySelector('[data-acm-main-image]');
      var thumbs = root.querySelectorAll('[data-acm-thumb]');
      var carousel = root.querySelector('[data-acm-pdp-carousel]');
      var track = root.querySelector('[data-acm-pdp-carousel-track]');
      var dots = root.querySelectorAll('[data-acm-pdp-carousel-dot]');

      if (main) thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (!full) return;
          main.setAttribute('src', full);
          thumbs.forEach(function (other) {
            other.classList.remove('on');
          });
          thumb.classList.add('on');
        });
      });

      if (!carousel || !track || !dots.length) return;

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = Number(dot.getAttribute('data-slide-index')) || 0;
          track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', function () {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('on', dotIndex === index);
        });
      }, { passive: true });
    });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    });
  }

  function updateCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart attribute update failed');
      return response.json();
    });
  }

  var MEMBERSHIP_VARIANT_IDS = ['45872260219078', '45872260251846', '45872260284614'];

  function isMembershipVariantId(id) {
    return MEMBERSHIP_VARIANT_IDS.indexOf(String(id || '')) !== -1;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      });
  }

  function updateCartLines(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart line update failed');
      return response.json();
    });
  }

  function cleanMembershipLines(options) {
    var opts = options || {};
    var preferredVariantId = opts.preferredVariantId ? String(opts.preferredVariantId) : '';
    var replaceExisting = Boolean(opts.replaceExisting);

    return fetchCart().then(function (cart) {
      var membershipLines = (cart.items || []).filter(function (item) {
        return isMembershipVariantId(item.variant_id);
      });
      var updates = {};
      var kept = false;

      membershipLines.forEach(function (item) {
        var variantId = String(item.variant_id || '');
        var shouldKeep = !replaceExisting && !kept && (!preferredVariantId || variantId === preferredVariantId);

        if (shouldKeep) {
          kept = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });

      var changed = Object.keys(updates).length > 0;
      if (!changed) return cart;

      return updateCartLines(updates);
    });
  }

  function addMembershipBundle(membershipItem, productItems, options) {
    var opts = options || {};
    var membershipId = membershipItem && membershipItem.id;
    if (!isMembershipVariantId(membershipId)) {
      return addItems([membershipItem].concat(productItems || []));
    }

    return cleanMembershipLines({
      preferredVariantId: membershipId,
      replaceExisting: opts.replaceExisting !== false
    }).then(function () {
      return addItems([membershipItem].concat(productItems || []));
    });
  }

  function apiBase() {
    return document.documentElement.getAttribute('data-acm-api') || '/apps/at-cost';
  }

  function submitCustomerLead(lead) {
    var root = document.querySelector('[data-acm-pdp]');
    var modal = document.querySelector('[data-acm-member-modal]');
    var selectedPlan = modal && modal.querySelector('input[name="acm_membership_variant"]:checked');
    var selectedVariant = root && root.querySelector('[data-acm-variant-select] option:checked');
    var productUrl = root && root.getAttribute('data-product-url');
    var payload = {
      name: lead.name,
      email: lead.email,
      source: 'pdp_membership_modal',
      productId: root && root.getAttribute('data-product-id'),
      productTitle: root && root.getAttribute('data-product-title'),
      productUrl: productUrl ? window.location.origin + productUrl : window.location.href,
      variantId: root && root.getAttribute('data-selected-variant-id'),
      variantTitle: selectedVariant ? selectedVariant.textContent.trim() : '',
      quantity: getProductQuantity(),
      selectedPlan: selectedPlan && selectedPlan.getAttribute('data-plan-title')
    };

    return fetch(apiBase() + '/api/customers', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Customer capture failed');
      return response.json();
    });
  }

  function refreshCartCount() {
    return fetchCart()
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        if (cart) renderCartDrawer(cart);
        return cart;
      })
      .catch(function () { return null; });
  }

  function renderCartDrawer(cart) {
    var drawer = document.querySelector('[data-acm-cart-drawer]');
    if (!drawer || !cart) return;

    var body = drawer.querySelector('[data-acm-cart-drawer-body]');
    var subtotal = drawer.querySelector('[data-acm-cart-drawer-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price || cart.total_price || 0);
    if (!body) return;

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="acm-cart-drawer-empty">Cart is empty.</div>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" loading="lazy">'
        : '<div class="acm-cart-drawer-placeholder"></div>';
      var meta = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var badge = isMembershipVariantId(item.variant_id) ? '<span class="acm-cart-drawer-badge">Membership</span>' : '';

      return '<div class="acm-cart-drawer-item" data-cart-key="' + escapeHtml(item.key) + '">' +
        '<div class="acm-cart-drawer-img">' + image + '</div>' +
        '<div class="acm-cart-drawer-info">' +
          '<div class="acm-cart-drawer-title">' + escapeHtml(item.product_title || item.title) + '</div>' +
          (meta ? '<div class="acm-cart-drawer-meta">' + escapeHtml(meta) + '</div>' : '') +
          '<div class="acm-cart-drawer-row"><span class="acm-mono">QTY ' + Number(item.quantity || 1) + '</span>' + badge + '</div>' +
        '</div>' +
        '<div class="acm-cart-drawer-price">' +
          '<span class="acm-mono">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="acm-cart-drawer-remove acm-mono" data-acm-cart-drawer-remove="' + escapeHtml(item.key) + '">REMOVE</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function openCartDrawer(cart) {
    var drawer = document.querySelector('[data-acm-cart-drawer]');
    if (!drawer) {
      if (cart) renderCartDrawer(cart);
      return;
    }
    if (cart) renderCartDrawer(cart);
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('acm-cart-drawer-open');
    var close = drawer.querySelector('[data-acm-cart-drawer-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-acm-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('acm-cart-drawer-open');
  }

  function initMemberModal() {
    var modal = document.querySelector('[data-acm-member-modal]');
    if (!modal) return;

    var openButtons = document.querySelectorAll('[data-acm-member-trigger]');
    var addButton = modal.querySelector('[data-acm-member-add]');
    var nextButton = modal.querySelector('[data-acm-member-next]');
    var closeButtons = modal.querySelectorAll('[data-acm-member-close]');
    var backButtons = modal.querySelectorAll('[data-acm-member-back]');
    var leadForm = modal.querySelector('[data-acm-member-lead]');
    var nameInput = modal.querySelector('[data-acm-member-name]');
    var emailInput = modal.querySelector('[data-acm-member-email]');
    var leadError = modal.querySelector('[data-acm-member-lead-error]');
    var lastFocusedTrigger = null;

    function normalizeMemberModalCopy() {
      var title = modal.querySelector('#AcmMemberModalTitle');
      var copy = modal.querySelector('[data-acm-member-modal-copy]');
      var add = modal.querySelector('[data-acm-member-add]');
      var planLabels = {
        '45872260219078': ['30 Days', 'Test the model', '<svg viewBox="0 0 24 24"><path d="M12 6v6l4 2"></path><circle cx="12" cy="12" r="8"></circle></svg>'],
        '45872260251846': ['90 Days', 'Stock-up window', '<svg viewBox="0 0 24 24"><path d="M4 9h16M8 5v4M16 5v4M6 7h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"></path><path d="m8 14 2.5 2.5L16 11"></path></svg>'],
        '45872260284614': ['1 Year', 'Lowest monthly equivalent', '<svg viewBox="0 0 24 24"><path d="M12 3 4 7v5c0 5 3.5 8 8 9 4.5-1 8-4 8-9V7l-8-4Z"></path><path d="m9 12 2 2 4-5"></path></svg>']
      };

      if (title) title.textContent = 'Select your access period.';
      if (copy) {
        copy.setAttribute('data-copy-available', 'Unlock unlimited member-priced orders while active. Built for serious buyers who stock up and skip retail markup.');
        copy.setAttribute('data-copy-unavailable', 'Choose your access period now, then shop unlimited member-priced restocks while your membership is active.');
      }
      if (add) {
        add.setAttribute('data-acm-member-add-label-available', 'Start access + add item');
        add.setAttribute('data-acm-member-add-label-unavailable', 'Start access');
      }

      modal.querySelectorAll('.acm-member-plan').forEach(function (plan) {
        var input = plan.querySelector('input[name="acm_membership_variant"]');
        var values = input && planLabels[input.value];
        if (!values) return;
        var titleEl = plan.querySelector('.acm-member-plan-title strong');
        var metaEl = plan.querySelector('.acm-member-plan-meta');
        if (titleEl) titleEl.textContent = values[0];
        if (metaEl) metaEl.textContent = values[1];
        if (!plan.querySelector('.acm-member-plan-icon')) {
          var icon = document.createElement('span');
          icon.className = 'acm-member-plan-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = values[2];
          var main = plan.querySelector('.acm-member-plan-main');
          if (main) plan.insertBefore(icon, main);
        }
      });

      if (!modal.querySelector('.acm-member-modal-value')) {
        var value = document.createElement('div');
        value.className = 'acm-member-modal-value';
        value.innerHTML = '<span class="acm-member-value-icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 9h16M8 5v4M16 5v4M6 7h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z"></path></svg></span><span><strong>90 days is the stock-up window.</strong><small>Catch restocks, build a freezer box, and let savings compound.</small></span>';
        var plans = modal.querySelector('[data-acm-member-plans]');
        if (plans) plans.parentNode.insertBefore(value, plans);
      }

      var proof = modal.querySelector('.acm-member-modal-proof');
      if (!proof) {
        proof = document.createElement('div');
        proof.className = 'acm-member-modal-proof';
        var button = modal.querySelector('[data-acm-member-add]');
        if (button) button.parentNode.insertBefore(proof, button);
      }
      if (proof) {
        proof.innerHTML = '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16"></path><path d="M12 4v16"></path></svg><strong>Unlimited purchasing while active</strong></span><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h10"></path></svg><strong>Every cut priced at cost</strong></span><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v18M7 7h7a3 3 0 0 1 0 6H9a3 3 0 0 0 0 6h8"></path></svg><strong>We make $0 on the meat itself</strong></span><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"></path></svg><strong>Cancel anytime</strong></span>';
      }
    }

    function showStep(stepName) {
      if (stepName === 'plan') {
        resetPlanStep();
      }
      modal.querySelectorAll('[data-acm-member-step]').forEach(function (step) {
        var active = step.getAttribute('data-acm-member-step') === stepName;
        step.hidden = !active;
        step.classList.toggle('on', active);
      });
      var focusTarget = stepName === 'lead'
        ? nameInput
        : modal.querySelector('input[name="acm_membership_variant"]') || addButton;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    function resetPlanStep() {
      var recommended = modal.querySelector('input[name="acm_membership_variant"][value="45872260251846"]');
      modal.querySelectorAll('input[name="acm_membership_variant"]').forEach(function (input) {
        input.checked = input === recommended;
      });
      modal.querySelectorAll('.acm-member-plan').forEach(function (plan) {
        plan.classList.toggle('selected', Boolean(plan.querySelector('input:checked')));
      });
      syncMemberSummary();
    }

    normalizeMemberModalCopy();

    function validateLead() {
      if (!nameInput && !emailInput) return {};

      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      var ok = Boolean(name) && emailOk;
      if (nameInput) nameInput.classList.toggle('invalid', !name);
      if (emailInput) emailInput.classList.toggle('invalid', !emailOk);
      if (leadError) leadError.hidden = ok;
      return ok ? { name: name, email: email } : null;
    }

    function syncMemberModalCopy(productAvailable) {
      var available = productAvailable === true || productAvailable === 'true';
      var copy = modal.querySelector('[data-acm-member-modal-copy]');
      if (copy) {
        copy.textContent = available
          ? copy.getAttribute('data-copy-available')
          : copy.getAttribute('data-copy-unavailable');
      }
      if (addButton) {
        addButton.textContent = available
          ? addButton.getAttribute('data-acm-member-add-label-available')
          : addButton.getAttribute('data-acm-member-add-label-unavailable');
      }
      syncMemberSummary();
    }

    function syncMemberSummary() {
      var root = document.querySelector('[data-acm-pdp]');
      var selectedPlan = modal.querySelector('input[name="acm_membership_variant"]:checked');
      var productAvailable = addButton && addButton.getAttribute('data-product-available') === 'true';
      var productQuantity = productAvailable ? getProductQuantity() : 0;
      var productPrice = Number(root && root.getAttribute('data-selected-variant-price')) || Number(root && root.querySelector('[data-acm-variant-select] option:checked') && root.querySelector('[data-acm-variant-select] option:checked').getAttribute('data-price')) || 0;
      var planPrice = Number(selectedPlan && selectedPlan.getAttribute('data-plan-price')) || 0;
      var planTitle = selectedPlan && selectedPlan.getAttribute('data-plan-title');
      var itemTotal = productPrice * productQuantity;
      var total = selectedPlan ? planPrice + itemTotal : itemTotal;
      var setText = function (selector, value) {
        var el = modal.querySelector(selector);
        if (el) el.textContent = value;
      };

      setText('[data-acm-member-summary-plan]', selectedPlan ? (planTitle ? planTitle + ' - ' : '') + formatMoney(planPrice) : 'Select below');
      setText('[data-acm-member-summary-qty]', String(productQuantity || 1));
      setText('[data-acm-member-summary-item]', productAvailable ? formatMoney(itemTotal) : 'Allocation pending');
      setText('[data-acm-member-summary-total]', formatMoney(total));
      if (addButton) {
        addButton.disabled = !selectedPlan;
        addButton.textContent = selectedPlan && productAvailable
          ? 'Start access + add item - ' + formatMoney(total)
          : 'Select access period';
      }
    }

    function openModal(button) {
      lastFocusedTrigger = button || document.activeElement;
      if (button && addButton) {
        addButton.setAttribute('data-product-variant-id', button.getAttribute('data-product-variant-id') || '');
        addButton.setAttribute('data-product-available', button.getAttribute('data-product-available') || 'false');
      }
      syncMemberModalCopy(addButton && addButton.getAttribute('data-product-available'));
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('acm-modal-open');
      showStep(leadForm ? 'lead' : 'plan');
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('acm-modal-open');
      if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
        lastFocusedTrigger.focus({ preventScroll: true });
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button);
      });
    });
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });
    backButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        showStep('lead');
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    modal.querySelectorAll('.acm-member-plan input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          modal.querySelectorAll('.acm-member-plan input').forEach(function (other) {
            if (other !== input) other.checked = false;
          });
        }
        modal.querySelectorAll('.acm-member-plan').forEach(function (plan) {
          plan.classList.toggle('selected', Boolean(plan.querySelector('input:checked')));
        });
        syncMemberSummary();
      });
    });

    [nameInput, emailInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        input.classList.remove('invalid');
        if (leadError) leadError.hidden = true;
      });
    });

    if (nextButton) {
      var continueToPlans = function () {
        var lead = validateLead();
        if (!lead) {
          return;
        }
        nextButton.disabled = true;
        Promise.allSettled([
          submitCustomerLead(lead),
          updateCartAttributes({
            'Member name': lead.name,
            'Member email': lead.email
          })
        ])
          .then(function () {
            showStep('plan');
          })
          .finally(function () {
            nextButton.disabled = false;
          });
      };

      nextButton.addEventListener('click', continueToPlans);
      if (leadForm) {
        leadForm.addEventListener('submit', function (event) {
          event.preventDefault();
          continueToPlans();
        });
      }
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var selectedPlan = modal.querySelector('input[name="acm_membership_variant"]:checked');
        var membershipId = selectedPlan && selectedPlan.value;
        var sellingPlanId = selectedPlan && selectedPlan.getAttribute('data-selling-plan-id');
        var productId = addButton.getAttribute('data-product-variant-id');
        var productAvailable = addButton.getAttribute('data-product-available') === 'true';
        var productQuantity = getProductQuantity();
        if (!membershipId || !sellingPlanId) {
          showToast('Select a membership plan');
          return;
        }
        var lead = validateLead();
        if (!lead) {
          showStep('lead');
          return;
        }

        var leadProperties = {};
        if (lead.name) leadProperties['Member name'] = lead.name;
        if (lead.email) leadProperties['Member email'] = lead.email;
        var membershipItem = { id: Number(membershipId), quantity: 1, selling_plan: Number(sellingPlanId), properties: leadProperties };
        var productItems = [];
        if (productId && productAvailable) {
          productItems.push({ id: Number(productId), quantity: productQuantity, properties: leadProperties });
        }

        addButton.disabled = true;
        if (lead.email) {
          submitCustomerLead(lead).catch(function () {
            return null;
          });
        }
        addMembershipBundle(membershipItem, productItems, { replaceExisting: true })
          .then(function () {
            if (!lead.name && !lead.email) return null;
            return updateCartAttributes(leadProperties);
          })
          .then(function () {
            showToast(productAvailable ? 'Membership and item added' : 'Membership added - item allocation pending');
            closeModal();
            return refreshCartCount().then(function (cart) {
              if (cart) openCartDrawer(cart);
            });
          })
          .catch(function () {
            showToast('Could not add membership. Please try again.');
          })
          .finally(function () {
            addButton.disabled = false;
          });
      });
    }
  }

  function initMembershipCartGuards() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="/cart/add"][href*="selling_plan"], .acm-hero-cta .acm-btn.primary, .acm-mobile-sticky-cta, .acm-savings-proof-actions .acm-btn.ghost, .acm-final-cta .acm-btn.primary');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var membershipId = '45872260251846';
      var sellingPlanId = '14266892486';
      if (href.indexOf('/cart/add') !== -1 && href.indexOf('selling_plan') !== -1) {
        try {
          var url = new URL(href, window.location.origin);
          membershipId = url.searchParams.get('id');
          sellingPlanId = url.searchParams.get('selling_plan');
        } catch (error) {
          return;
        }
      }
      if (!isMembershipVariantId(membershipId) || !sellingPlanId) return;

      event.preventDefault();
      link.setAttribute('aria-busy', 'true');

      addMembershipBundle({
        id: Number(membershipId),
        quantity: 1,
        selling_plan: Number(sellingPlanId)
      }, [], { replaceExisting: true })
        .then(function () {
          return refreshCartCount();
        })
        .then(function (cart) {
          showToast('Membership added - keep building your box');
          if (cart) openCartDrawer(cart);
          link.removeAttribute('aria-busy');
        })
        .catch(function () {
          showToast('Could not update membership. Please try again.');
          link.removeAttribute('aria-busy');
        });
    });

    if (document.body.className.indexOf('template-cart') !== -1) {
      cleanMembershipLines({ replaceExisting: false })
        .then(function (cart) {
          if (cart && cart.items) updateCartCount(cart.item_count);
        })
        .catch(function () { return null; });
    }
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-acm-cart-drawer]');
    if (!drawer) return;

    document.addEventListener('click', function (event) {
      var cartLink = event.target.closest('.acm-nav-cart, .acm-mobile-nav-panel a[href="/cart"]');
      if (cartLink && window.fetch) {
        event.preventDefault();
        fetchCart()
          .then(function (cart) {
            updateCartCount(cart.item_count);
            openCartDrawer(cart);
          })
          .catch(function () {
            window.location.href = cartLink.getAttribute('href') || '/cart';
          });
        return;
      }

      if (event.target.closest('[data-acm-cart-drawer-close]')) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var removeButton = event.target.closest('[data-acm-cart-drawer-remove]');
      if (removeButton) {
        event.preventDefault();
        var key = removeButton.getAttribute('data-acm-cart-drawer-remove');
        if (!key) return;
        removeButton.disabled = true;
        var updates = {};
        updates[key] = 0;
        updateCartLines(updates)
          .then(function (cart) {
            updateCartCount(cart.item_count);
            renderCartDrawer(cart);
          })
          .catch(function () {
            removeButton.disabled = false;
            showToast('Could not remove item. Please try again.');
          });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeCartDrawer();
    });
  }

  function initStickyCta() {
    document.querySelectorAll('[data-acm-pdp]').forEach(function (root) {
      var sticky = root.querySelector('[data-acm-sticky-cta]');
      var mainCta = root.querySelector('[data-acm-main-cta]');
      if (!sticky || !mainCta || !window.IntersectionObserver) return;
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        sticky.classList.toggle('is-visible', !visible);
      }, { threshold: 0.1 });
      observer.observe(mainCta);
    });
  }

  function initProductToast() {
    var forms = document.querySelectorAll('[data-acm-product-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function (item) {
            showToast('Added - ' + (item.product_title || item.title || 'Item'));
            return refreshCartCount();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    });
  }

  function initHomepageProductLinks() {
    var receipt = document.querySelector('.acm-hero-receipt .acm-receipt');
    if (!receipt) return;

    var productLink = receipt.querySelector('.acm-receipt-link[href*="/products/"]');
    var productUrl = productLink && productLink.getAttribute('href');
    if (!productUrl) return;

    if (productLink) productLink.textContent = 'VIEW PRODUCT →';

    var image = receipt.querySelector('.acm-receipt-img');
    if (image && image.tagName !== 'A') {
      image.setAttribute('role', 'link');
      image.setAttribute('tabindex', '0');
      image.setAttribute('aria-label', 'View product');
      image.addEventListener('click', function () {
        window.location.href = productUrl;
      });
      image.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.location.href = productUrl;
        }
      });
    }

    var cta = receipt.querySelector('.acm-receipt-add');
    if (cta) {
      cta.setAttribute('href', productUrl);
      cta.innerHTML = 'View Product <span aria-hidden="true">→</span>';
    }
  }

  function initHeaderCollectionLinks() {
    var panel = document.querySelector('.acm-nav-menu-panel');
    var mobilePanel = document.querySelector('.acm-mobile-nav-panel');
    var collections = [
      ['Premium meats', '/collections/premium-meats', 'The main launch assortment'],
      ['A5 Japanese Wagyu', '/collections/japanese-a5-wagyu', 'Kagoshima, Miyazaki, and allocated imports'],
      ['Australian Wagyu', '/collections/australian-wagyu', 'Fullblood and high-marbling everyday cuts'],
      ['Halal Wagyu', '/collections/halal-wagyu-beef', 'Halal-certified Wagyu and premium beef'],
      ['USDA Prime Beef', '/collections/american-prime-beef', 'Prime ribeye, strip, filet, and beef staples'],
      ['Ribeyes', '/collections/ribeyes', 'A5, Wagyu, Prime, and dry-aged ribeyes'],
      ['Filet Mignon', '/collections/filet-mignon', 'Tenderloin cuts across premium programs'],
      ['Fish & Seafood', '/collections/fish-seafood', 'Premium fish and shellfish when stocked']
    ];

    if (panel && !panel.querySelector('a[href="/collections/australian-wagyu"]')) {
      panel.innerHTML = '<a href="/collections/all"><span>Full catalog</span><small>Every available cut at member price</small></a>' +
        collections.map(function (item) {
          return '<a href="' + item[1] + '"><span>' + item[0] + '</span><small>' + item[2] + '</small></a>';
        }).join('');
    }

    if (mobilePanel && !mobilePanel.querySelector('a[href="/collections/australian-wagyu"]')) {
      var firstLink = mobilePanel.querySelector('a[href="/collections/all"]');
      if (firstLink) {
        collections.slice(0, 6).reverse().forEach(function (item) {
          var link = document.createElement('a');
          link.href = item[1];
          link.textContent = item[0];
          firstLink.insertAdjacentElement('afterend', link);
        });
      }
    }
  }

  function initIndexGroupLabels() {
    var index = document.querySelector('#index');
    var row = index && index.querySelector('.acm-villains-row');
    if (!index || !row || index.querySelector('.acm-villains-groups')) return;

    var cards = row.querySelectorAll('.acm-villain');
    var costCount = row.querySelectorAll('.acm-villain.prod').length;
    var cutCount = row.querySelectorAll('.acm-villain.cut').length;
    if (!cards.length || !costCount || !cutCount) return;

    var groups = document.createElement('div');
    groups.className = 'acm-villains-groups';
    groups.setAttribute('aria-hidden', 'true');
    groups.style.gridTemplateColumns = 'repeat(' + cards.length + ', minmax(0, 1fr))';
    groups.innerHTML =
      '<div class="acm-villains-group-label cost" style="grid-column: 1 / span ' + costCount + ';">' +
        '<div class="bracket"></div><div class="label acm-mono">What it Actually Costs</div>' +
      '</div>' +
      '<div class="acm-villains-group-label cut" style="grid-column: ' + (costCount + 1) + ' / span ' + cutCount + ';">' +
        '<div class="bracket"></div><div class="label acm-mono">Middle Man Profit</div>' +
      '</div>';

    row.insertAdjacentElement('beforebegin', groups);
    row.style.paddingTop = '16px';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVariantSelectors();
      initQuantitySelectors();
      initThumbs();
      initMemberModal();
      initProductToast();
      initStickyCta();
      initHomepageProductLinks();
      initHeaderCollectionLinks();
      initIndexGroupLabels();
      initMembershipCartGuards();
      initCartDrawer();
    });
  } else {
    initVariantSelectors();
    initQuantitySelectors();
    initThumbs();
    initMemberModal();
    initProductToast();
    initStickyCta();
    initHomepageProductLinks();
    initHeaderCollectionLinks();
    initIndexGroupLabels();
    initMembershipCartGuards();
    initCartDrawer();
  }
})();
